import CustomerService from '@/services/customers-service';
import pageKeyNames from '@/utils/page-key-names';
import AuthorizationManager from '@/authorization/authorization-manager.js';

export default {
	props: {
		customerId: String
	},
	computed: {
		actions() {
			const { customerId } = this.$route.params;
			return [
				{
					id: 1,
					action: this.vueLoginByPass,
					disabled: false,
					iconClass: 'icon icon-vue',
					label: 'VUE',
					title: 'Select to go to the home page',
					type: 'anchor',
					visible: this.hasCustomerUpdatePermission,
					loggingParams: {
						event: 'click',
						target: 'Vue Login Bypass',
						eventData: this.customerData
					}
				},
				{
					id: 2,
					action: {
						path: `/clients/${this.customerData?.customerId}/companies`
					},
					disabled: true,
					iconClass: 'icon icon-manage',
					label: 'Settings',
					title: 'Select to go to the default settings',
					type: 'route-link',
					visible: this.hasCustomerDefaultSettingPermission,
					loggingParams: {
						event: 'click',
						target: 'Vue Login Bypass',
						eventData: this.customerData
					}
				},
				{
					id: 3,
					action: this.displayCompany,
					disabled: false,
					iconClass: 'icon icon-company',
					label: 'Companies',
					title: 'Select to go to the Company Page',
					type: 'anchor',
					visible: this.hasCustomerCompanyPermission,
					valueBadgeCount:
						this.customer?.companies?.length > 1
							? this.customer?.companies?.length
							: 0,
					loggingParams: {
						event: 'click',
						target: 'Go to Company Page',
						eventData: this.customerData
					}
				},
				{
					id: 4,
					action: {
						path: `/clients/${this.customerData?.customerId}/error-logs`,
						activePage: pageKeyNames.CUSTOMER_ERROR_LOGS
					},
					disabled: true,
					iconClass: 'icon icon-error',
					label: 'Error Log',
					title: 'Select to go to the Error Logs page',
					type: 'route-link',
					visible: this.hasCustomerErrorLogPermission,
					loggingParams: {
						event: 'click',
						target: 'Go to Error Log Page',
						eventData: this.customerData
					}
				},
				{
					id: 5,
					action: '#',
					disabled: true,
					iconClass: 'icon icon-transaction',
					label: 'Transactions',
					title: 'Select to go to the transactions page',
					type: 'route-link',
					visible: this.hasTransactionsPermission,
					loggingParams: {
						event: 'click',
						target: 'Go to Transactions Page',
						eventData: this.customerData
					}
				},
				{
					id: 6,
					action: '#',
					disabled: false,
					iconClass: 'icon icon-menu',
					label: 'More',
					title: 'select to see the more actions',
					type: 'dropdown',
					visible: this.hasReadPermission,
					items: [
						{
							id: 6,
							action: {
								path: `/clients/${customerId ||
									this.customerData.customerId}/forms`,
								activePage: pageKeyNames.FORM
							},
							disabled: false,
							iconClass: 'icon icon-document',
							label: 'Forms',
							title: 'Select to go to the form page',
							type: 'route-link',
							visible: this.hasReadPermission,
							loggingParams: {
								event: 'click',
								target: 'Go to Form Page',
								eventData: this.customerData
							}
						}
					],
					loggingParams: {
						event: 'click',
						target: 'More Button',
						eventData: this.customerData
					}
				}
			];
		},
		customerData() {
			const user = this.$store.getters['oidcStore/oidcUser'];
			const params = {
				customerId: this.customer?.id,
				userId: user.sub,
				email: user.Email
			};

			if (this.$options.name === 'CompanyCard') {
				params.cid = this.company.companyId;
			}
			if (this.$options.name === 'LocationCard') {
				params.cid = this.location.companyLocationId;
			}

			return params;
		},
		// DEV NOTE: WIP. ASK PRODUCT
		settingsPath() {
			switch (this.$options.name) {
				case 'CompanyCard':
					return {
						path: `/clients/${this.customerData?.customerId}/companies/${this.company?.companyCode}`
					};
				case 'LocationCard':
					return {
						path: `/clients/${this.customerData?.customerId}/companies/${this.company?.companyCode}`
					};
				default:
					// TODO: Customer settings
					return {
						path: '#'
					};
			}
		},
		hasCustomerDefaultSettingPermission() {
			return this.authorize(['clients.read']);
		},
		hasMultipleCompanies() {
			return this.customer?.companies?.length > 1;
		},
		hasCustomerCompanyPermission() {
			return (
				this.hasMultipleCompanies && this.authorize(['clients.read'])
			);
		},
		hasCustomerErrorLogPermission() {
			return (
				this.customer?.companies?.length === 1 &&
				this.authorize(['clients.read'])
			);
		},
		hasTransactionsPermission() {
			return this.authorize(['transactions.read']);
		},
		hasReadPermission() {
			return this.authorize(['forms.read']);
		},
		hasCustomerUpdatePermission() {
			const authorization = {
				permissions: ['clients.update']
			};
			return AuthorizationManager.validate(authorization);
		}
	},
	methods: {
		async vueLoginByPass(e) {
			if (e) e.preventDefault();
			const self = this;
			await CustomerService.VueLoginBypass(self.customerData)
				.then(response => {
					if (response && response.bypassUrl) {
						const url = this.customerData.cid
							? `${response.bypassUrl}&cid=${this.customerData.cid}`
							: `${response.bypassUrl}`;
						window.open(url, '_blank');
					}
				})
				.catch(error => {
					let status = 0;
					error ? (status = 400) : status;
					self.updateToast({ status: status, message: error });
				});
		},
		updateToast(val) {
			this.$store.dispatch('toastMessages/show', {
				toastId: 'clients.action',
				statusCode: val.status,
				message: val.message,
				slot: 'default',
				useIcon: true,
				userDismissable: true
			});
		},
		getAuthorization(permissions) {
			const authorization = {
				permissions,
				policies: ['InternalSupportTech']
			};
			return authorization;
		},
		authorize(permissions) {
			const authorization = this.getAuthorization(permissions);
			return AuthorizationManager.validate(authorization);
		}
	}
};
